var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Identitas (KTP/NPWP/SIM)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_identitas))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_identitas_penerima) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_identitas_penerima))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]), _vm._v(" "), (_vm.$store.state.barpin.header.fl_kuasa) ? _c('tr', [_c('td', [_vm._v("Identitas Kuasa (KTP/NPWP/SIM)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_identitas_kuasa))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_identitas_pengirim) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_identitas_pengirim))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '2') ? _c('tr', [_c('td', [_vm._v("Nomor STNK")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_stnk))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_stnk))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_stnk) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_stnk))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '2') ? _c('tr', [_c('td', [_vm._v("Nomor BPKB")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_bpkb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_bpkb))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_bpkb) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_bpkb))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_c('td', [_vm._v("Kartu Keluarga")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_kk))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_kk) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_kk))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_c('td', [_vm._v("Surat Pindah Dukcapil")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_dukcapil))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_dukcapil))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_dukcapil) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_dukcapil))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_c('td', [_vm._v("Surat Keterangan Mutasi/lainnya")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_surat_pindah))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_pindah))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_pindah) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_pindah))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.fl_kuasa) ? _c('tr', [_c('td', [_vm._v("Surat Kuasa")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_surat_kuasa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_surat_kuasa))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_kuasa) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_kuasa))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Surat Pernyataan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_surat_pernyataan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_surat_pernyataan))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_pernyataan) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_pernyataan))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_c('td', [_vm._v("Surat Rekomendasi BP")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_surat_rekombp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_surat_rekombp))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_rekombp) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_rekombp))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Packing List")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_pl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_pl))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_pl) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_pl))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '2') ? _c('tr', [_c('td', [_vm._v("Bukti Bayar")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_ntpn))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_ntpn))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_ntpn) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_ntpn))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("File Upload")]), _vm._v(" "), _c('th', [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th')])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-939c914e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/browse/ListFilePpftz.vue
// module id = 386
// module chunks = 0